import React from 'react'

import { NewsletterApi } from '../../../api/Newsletter'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import Newsletter from './Newsletter'

function NewsletterCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => NewsletterApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)

  return (
    <Newsletter
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}

export default NewsletterCont
